import React, {Component} from 'react';
import logo from '../img/logo.png';
import music from '../audio/bernes.wav';
import {NavLink} from "react-router-dom";
import axios from 'axios';
import Hero from "./Hero";

class Main extends Component {

    state = {
        persons: []
    };

    async componentDidMount() {
        try {
            const response = await axios.get('https://bgn-heroes.firebaseio.com/persons.json');
            console.log(response.data)

            const persons = Object.entries(response.data).map((person) => {
                return {
                    personId: person[0],
                    personData: person[1]
                }
            });

            console.log(persons);
            this.setState({
                persons
            })
        } catch (e) {
            console.log(e)
        }
    }

    render() {
        return (
            <div className={'Main'}>
                <div className="Main__intro">
                    <div className="Main__header wow fadeInDown">
                        <div className="logos">
                            <img src={logo} alt=""/>
                            <p>Брянская областная нотариальная палата</p>
                        </div>
                    </div>
                    <div className="Main__content wow fadeIn">
                        <h1>В честь 75-летия Великой Победы</h1>
                    </div>
                    <audio src={music} autoPlay controls/>
                </div>
                <div className="Main__heroes">
                    <div className="container">
                        <div className="row">
                            <h1 className="wow fadeInDown">Наши герои</h1>
                        </div>
                        {this.state.persons.map((hero, index) => {
                            return (
                                <Hero
                                    key={hero+index}
                                    name={hero.personData.name}
                                    lifeTime={hero.personData.lifeTime}
                                    rank={hero.personData.rank}
                                    picUrl={hero.personData.url}
                                    information={hero.personData.information}
                                    id={hero.personId}
                                />
                            )
                        })}
                    </div>
                </div>
                <div className="rights">
                    <p className='wow fadeInUp'>2020. Made by <span><a href="http://rauventa.ru">Rauventa</a></span>. All rights reserved</p>
                </div>
            </div>
        );
    }
}

export default Main;